/* ============================================================
   SHUDHI — PRODUCT PAGE (assets/sh-product.js)
   Pairs with sections/sh-product.liquid.

   What this file is NOT responsible for — the section works without it:
   - Adding to cart. The section renders a real form[action^="/cart/add"];
     assets/ajax-cart.js.liquid's delegated submit handler owns the POST,
     the drawer, the count and the 'cart:updated' event.
   - Button busy states. assets/hov-cart-checkout.js converts the submit
     button and drives data-state="loading|success" itself.
   - Initial render. Every price, badge, caption and the checked radio are
     server-rendered. Losing this file costs pack SWITCHING, the countdown,
     the qty stepper, the gallery (thumbs, arrows, swipe, zoom viewer, autoplay)
     and the mobile sticky bar — the page
     still sells the default pack.

   This file's one real job is the state transition: checked radio ->
   hidden [name="id"] + price row + savings row + availability + sticky bar
   + gallery + URL. Everything else here is small conveniences around it.

   House conventions: IIFE, ES5-friendly, __shPD single-execution guard,
   boot on readyState, re-boot on shopify:section:load with a
   document.contains() sweep, per-root data-sh-init idempotency,
   matchMedia (never innerWidth), reduced-motion respected.
   ============================================================ */
(function () {
  'use strict';

  if (window.__shPD) return;
  window.__shPD = true;

  var REDUCED = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };

  /* one cleanup registry so a theme-editor section reload never leaks a
     ticking interval or a dangling observer */
  var instances = [];

  function sweep() {
    instances = instances.filter(function (inst) {
      if (document.contains(inst.root)) return true;
      inst.destroy();
      return false;
    });
  }

  /* ---------------------------------------------------------- money */

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    /* fallback: the two placeholders this store's formats actually use */
    var value = (cents / 100).toFixed(2).split('.');
    value[0] = value[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, value.join('.'));
  }

  /* ---------------------------------------------------------- boot */

  function initRoot(root) {
    if (root.hasAttribute('data-sh-init')) return;
    root.setAttribute('data-sh-init', '1');

    var moneyFormat = root.getAttribute('data-sh-money') || '{{amount}}';
    var moneyCurrencyFormat = root.getAttribute('data-sh-money-currency') || moneyFormat;

    /* variant data — one JSON island, keyed by id */
    var variants = {};
    var dataEl = root.querySelector('[data-sh-variants]');
    if (dataEl) {
      try {
        JSON.parse(dataEl.textContent).forEach(function (v) {
          variants[String(v.id)] = v;
        });
      } catch (e) { /* malformed JSON: switching degrades, default still sells */ }
    }

    var form = root.querySelector('[data-sh-form]') || root.querySelector('form[action*="/cart/add"]');
    var idInput = root.querySelector('[data-sh-id]');
    var priceEl = root.querySelector('[data-sh-price]');
    var savingEl = root.querySelector('[data-sh-saving]');
    var savingAmountEl = root.querySelector('[data-sh-saving-amount]');
    var leadWasEl = root.querySelector('[data-sh-lead-was]');
    var leadWasAmountEl = root.querySelector('[data-sh-lead-was-amount]');
    var leadOffEl = root.querySelector('[data-sh-lead-off]');
    var couponEl = root.querySelector('[data-sh-coupon]');
    var couponAmountEl = root.querySelector('[data-sh-coupon-amount]');
    var dotEl = root.querySelector('[data-sh-dot]');
    var availSrEl = root.querySelector('[data-sh-avail-sr]');
    var atcBtn = root.querySelector('[data-sh-atc]');
    var stickyBar = root.querySelector('[data-sh-sticky]');
    var stickyTitle = root.querySelector('[data-sh-sticky-title]');
    var stickyAmt = root.querySelector('[data-sh-sticky-amt]');
    var stickyAtc = root.querySelector('[data-sh-sticky-atc]');

    var cleanups = [];

    /* ------------------------------------------------ ATC label
       hov-cart-checkout.js rewrites the button into three spans; after that,
       the label lives in .hov-cart__btn-default. Before it (or if it never
       runs), the button's own text is the label. */
    function setAtcLabel(btn, text) {
      if (!btn) return;
      var inner = btn.querySelector('.hov-cart__btn-default');
      if (!inner) {
        btn.textContent = text;
        return;
      }
      /* the converted span is <svg> + a text node: replace only the text so
         the bag icon the conversion drew survives the update */
      var nodes = inner.childNodes;
      var textNode = null;
      for (var i = nodes.length - 1; i >= 0; i--) {
        if (nodes[i].nodeType === 3 && nodes[i].nodeValue.trim()) {
          textNode = nodes[i];
          break;
        }
      }
      if (textNode) {
        textNode.nodeValue = ' ' + text;
      } else {
        inner.appendChild(document.createTextNode(' ' + text));
      }
    }

    /* ------------------------------------------------ gallery
       Index-based. Slides are the product's media followed by any
       theme-editor gallery_image blocks (data-media-id="b-<block id>");
       the thumbs mirror that order. activateMedia(id) stays the entry point
       for variant switching (setVariant below) and maps the id to an index. */

    var stage = root.querySelector('[data-sh-stage]');
    var rail = root.querySelector('[data-sh-thumbs]');
    var gallerySr = root.querySelector('[data-sh-gallery-sr]');
    var zoomBtn = root.querySelector('[data-sh-zoom]');
    var current = 0;

    function slides() {
      return stage ? stage.querySelectorAll('.sh-pdp__slide') : [];
    }

    function thumbs() {
      return root.querySelectorAll('.sh-pdp__thumb');
    }

    function indexOfMedia(mediaId) {
      var list = slides();
      for (var i = 0; i < list.length; i++) {
        if (list[i].getAttribute('data-media-id') === String(mediaId)) return i;
      }
      return -1;
    }

    /* Centre the active thumb inside the rail WITHOUT scrollIntoView, which
       would scroll the window too (a pack change must never jump the page). */
    function revealThumb(i) {
      var t = thumbs()[i];
      if (!t || !rail) return;
      var left = t.offsetLeft - (rail.clientWidth - t.offsetWidth) / 2;
      var top = t.offsetTop - (rail.clientHeight - t.offsetHeight) / 2;
      try {
        rail.scrollTo({ left: left, top: top, behavior: REDUCED.matches ? 'auto' : 'smooth' });
      } catch (e) {
        rail.scrollLeft = left;
        rail.scrollTop = top;
      }
    }

    /* userInitiated: the shopper picked this image, so autoplay gives up for
       good. auto: the autoplay timer picked it — it still crossfades, but stays
       out of the aria-live region, which would otherwise read out "Image 3 of
       12" every few seconds. */
    function showIndex(i, userInitiated, auto) {
      var list = slides();
      if (!list.length || i < 0 || i >= list.length) return;
      for (var s = 0; s < list.length; s++) list[s].classList.toggle('is-active', s === i);
      var ts = thumbs();
      for (var t = 0; t < ts.length; t++) {
        if (t === i) ts[t].setAttribute('aria-current', 'true');
        else ts[t].removeAttribute('aria-current');
      }
      current = i;
      if (gallerySr && !auto) gallerySr.textContent = 'Image ' + (i + 1) + ' of ' + list.length;
      /* the crossfade is armed by a user action (or autoplay) only, never on first paint */
      if ((userInitiated || auto) && stage) stage.classList.add('is-live');
      if (userInitiated) autoStop();
      revealThumb(i);
      if (lightboxOpen()) lbShow(i);
      autoSchedule();
    }

    function activateMedia(mediaId) {
      if (!mediaId) return;
      var i = indexOfMedia(mediaId);
      if (i > -1) showIndex(i, false);
    }

    function stepMedia(dir) {
      var n = slides().length;
      if (n < 2) return;
      showIndex((current + dir + n) % n, true);
    }

    /* Touch swipe. Mouse pointers are ignored (they have the arrows, and a
       mouse drag on an <img> starts a native image drag). The `swiped` flag
       lets the click handler tell a tap from the end of a swipe. */
    function attachSwipe(el, onSwipe) {
      var state = { id: null, x: 0, y: 0, swiped: false };
      if (!el || !window.PointerEvent) return state;
      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse') return;
        state.id = e.pointerId;
        state.x = e.clientX;
        state.y = e.clientY;
        state.swiped = false;
      });
      el.addEventListener('pointerup', function (e) {
        if (e.pointerId !== state.id) return;
        state.id = null;
        var dx = e.clientX - state.x;
        var dy = e.clientY - state.y;
        if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) {
          state.swiped = true;
          onSwipe(dx < 0 ? 1 : -1);
        }
      });
      el.addEventListener('pointercancel', function () { state.id = null; });
      return state;
    }

    var stageSwipe = attachSwipe(stage, stepMedia);

    if (stage) {
      stage.addEventListener('keydown', function (evt) {
        if (evt.key === 'ArrowLeft' || evt.keyCode === 37) { evt.preventDefault(); stepMedia(-1); }
        if (evt.key === 'ArrowRight' || evt.keyCode === 39) { evt.preventDefault(); stepMedia(1); }
      });
      stage.addEventListener('dragstart', function (evt) { evt.preventDefault(); });
      /* a tap or click on the picture opens the viewer; the end of a swipe does not */
      stage.addEventListener('click', function (evt) {
        if (!evt.target.closest || evt.target.closest('button')) return;
        if (stageSwipe.swiped) { stageSwipe.swiped = false; return; }
        if (evt.target.closest('.sh-pdp__slide img')) openLightbox(current);
      });
    }

    root.addEventListener('click', function (evt) {
      var t = evt.target;
      if (!t.closest) return;
      var thumb = t.closest('.sh-pdp__thumb');
      if (thumb && root.contains(thumb)) {
        showIndex(indexOfMedia(thumb.getAttribute('data-media-id')), true);
        return;
      }
      var nav = t.closest('[data-sh-nav]');
      if (nav && root.contains(nav)) {
        stepMedia(parseInt(nav.getAttribute('data-sh-nav'), 10) || 1);
        return;
      }
      var zoom = t.closest('[data-sh-zoom]');
      if (zoom && root.contains(zoom)) openLightbox(current);
    });

    /* initial index: whichever slide Liquid marked active */
    (function () {
      var list = slides();
      for (var i = 0; i < list.length; i++) {
        if (list[i].classList.contains('is-active')) { current = i; break; }
      }
    })();
    /* ------------------------------------------------ lightbox
       Native <dialog>: showModal() gives the top layer, focus containment and
       Escape for free. Every close path ends in dialog.close(), and the one
       'close' listener does all the teardown. No document-level listeners. */

    var dialog = root.querySelector('[data-sh-lightbox]');
    var lbImg = dialog && dialog.querySelector('[data-sh-lb-img]');
    var lbStage = dialog && dialog.querySelector('[data-sh-lb-stage]');
    var lbCount = dialog && dialog.querySelector('[data-sh-lb-count]');
    var lbZoom = dialog && dialog.querySelector('[data-sh-lb-zoom]');
    var lbIndex = 0;
    var opener = null;

    function lightboxOpen() {
      return !!(dialog && dialog.open);
    }

    function slideLarge(i) {
      var list = slides();
      var img = list[i] ? list[i].querySelector('img') : null;
      if (!img) return null;
      return { src: img.getAttribute('data-large') || img.currentSrc || img.src, alt: img.alt || '' };
    }

    function lbLoaded() {
      if (dialog) dialog.classList.remove('is-loading');
    }

    function unmagnify() {
      if (!dialog) return;
      dialog.classList.remove('is-zoomed');
      if (lbZoom) lbZoom.setAttribute('aria-pressed', 'false');
    }

    function magnifyAt(fx, fy) {
      if (!dialog || !lbImg) return;
      lbImg.style.setProperty('--sh-lb-ox', (fx * 100).toFixed(1) + '%');
      lbImg.style.setProperty('--sh-lb-oy', (fy * 100).toFixed(1) + '%');
      dialog.classList.add('is-zoomed');
      if (lbZoom) lbZoom.setAttribute('aria-pressed', 'true');
    }

    function toggleMagnify(evt) {
      if (!dialog) return;
      if (dialog.classList.contains('is-zoomed')) { unmagnify(); return; }
      var fx = 0.5, fy = 0.5;
      if (evt && lbImg && evt.clientX) {
        var r = lbImg.getBoundingClientRect();
        if (r.width && r.height) {
          fx = Math.min(1, Math.max(0, (evt.clientX - r.left) / r.width));
          fy = Math.min(1, Math.max(0, (evt.clientY - r.top) / r.height));
        }
      }
      magnifyAt(fx, fy);
    }

    function lbShow(i) {
      var d = slideLarge(i);
      if (!d || !lbImg) return;
      lbIndex = i;
      unmagnify();
      dialog.classList.add('is-loading');
      lbImg.alt = d.alt;
      lbImg.src = d.src;
      if (lbImg.complete && lbImg.naturalWidth) lbLoaded();
      var n = slides().length;
      if (lbCount) lbCount.textContent = (i + 1) + ' / ' + n;
      if (n > 1) {
        var next = slideLarge((i + 1) % n);
        var prev = slideLarge((i - 1 + n) % n);
        if (next) new Image().src = next.src;
        if (prev) new Image().src = prev.src;
      }
    }

    function lbStep(dir) {
      var n = slides().length;
      if (n < 2) return;
      lbShow((lbIndex + dir + n) % n);
    }

    function openLightbox(i) {
      var d = slideLarge(i);
      if (!d) return;
      if (!dialog || typeof dialog.showModal !== 'function') {
        window.open(d.src, '_blank', 'noopener');
        return;
      }
      if (dialog.open) return;
      autoStop();   /* showIndex would otherwise drag the open viewer along */
      opener = document.activeElement;
      lbShow(i);
      document.documentElement.classList.add('sh-pdp-lightbox-open');
      dialog.showModal();
    }

    if (dialog && lbImg) {
      var lbSwipe = attachSwipe(lbStage, function (dir) {
        if (!dialog.classList.contains('is-zoomed')) lbStep(dir);
      });

      lbImg.addEventListener('load', lbLoaded);
      lbImg.addEventListener('error', lbLoaded);

      dialog.addEventListener('click', function (evt) {
        var t = evt.target;
        if (!t.closest) return;
        if (t.closest('[data-sh-lb-close]')) { dialog.close(); return; }
        var nav = t.closest('[data-sh-lb-nav]');
        if (nav) { lbStep(parseInt(nav.getAttribute('data-sh-lb-nav'), 10) || 1); return; }
        if (t.closest('[data-sh-lb-zoom]')) { toggleMagnify(null); return; }
        if (t === lbImg) {
          if (!lbSwipe.swiped) toggleMagnify(evt);
          lbSwipe.swiped = false;
          return;
        }
        if (t === dialog || t === lbStage) dialog.close();
      });

      dialog.addEventListener('keydown', function (evt) {
        if (evt.key === 'ArrowLeft' || evt.keyCode === 37) { evt.preventDefault(); lbStep(-1); }
        if (evt.key === 'ArrowRight' || evt.keyCode === 39) { evt.preventDefault(); lbStep(1); }
      });

      dialog.addEventListener('close', function () {
        document.documentElement.classList.remove('sh-pdp-lightbox-open');
        unmagnify();
        /* the stage follows the last-viewed image */
        if (lbIndex !== current) showIndex(lbIndex, true);
        var target = (opener && root.contains(opener) && opener !== document.body) ? opener : zoomBtn;
        opener = null;
        if (target && target.focus) { try { target.focus(); } catch (e) { /* detached */ } }
      });

      cleanups.push(function () {
        if (dialog.open) dialog.close();
        document.documentElement.classList.remove('sh-pdp-lightbox-open');
      });
    }

    /* ------------------------------------------------ autoplay
       Steps the gallery on a timer, and the thumb rail follows because
       showIndex() recentres the active thumb. Off unless Liquid wrote
       data-sh-autoplay (milliseconds) on the stage, and never started for
       visitors who prefer reduced motion.
       Two ways to not advance. A HOLD is temporary (pointer over the gallery,
       focus inside it, gallery scrolled out of view, tab hidden) and the timer
       re-arms when it lifts. A STOP is for good: the shopper picked a photo
       themselves, or opened the zoom viewer. Every showIndex() re-arms the
       timer, so each photo gets its full time on screen however it was reached. */

    var autoMs = stage ? parseInt(stage.getAttribute('data-sh-autoplay'), 10) || 0 : 0;
    var autoTimer = null;
    var autoStopped = false;
    var autoHolds = {};

    function autoStop() {
      autoStopped = true;
      clearTimeout(autoTimer);
    }

    function autoHeld() {
      for (var k in autoHolds) {
        if (autoHolds[k]) return true;
      }
      return false;
    }

    function autoHold(key, on) {
      autoHolds[key] = on;
      autoSchedule();
    }

    /* Slides after the first are loading="lazy" inside display:none, so the next
       one has not been fetched yet. Flipping it to eager starts the download a
       whole dwell ahead of the swap, so the crossfade lands on a painted photo. */
    function warmSlide(i) {
      var slide = slides()[i];
      var img = slide && slide.querySelector('img');
      if (img && img.loading === 'lazy') img.loading = 'eager';
    }

    function autoSchedule() {
      clearTimeout(autoTimer);
      var n = slides().length;
      if (!autoMs || autoStopped || n < 2 || autoHeld() || REDUCED.matches) return;
      warmSlide((current + 1) % n);
      autoTimer = setTimeout(function () {
        showIndex((current + 1) % n, false, true);
      }, autoMs);
    }

    if (autoMs && stage) {
      var galleryEl = stage.parentNode;   /* the stage plus its thumb rail */
      galleryEl.addEventListener('mouseenter', function () { autoHold('hover', true); });
      galleryEl.addEventListener('mouseleave', function () { autoHold('hover', false); });
      galleryEl.addEventListener('focusin', function () { autoHold('focus', true); });
      galleryEl.addEventListener('focusout', function (evt) {
        if (!evt.relatedTarget || !galleryEl.contains(evt.relatedTarget)) autoHold('focus', false);
      });

      var onVisibility = function () { autoHold('hidden', document.hidden); };
      document.addEventListener('visibilitychange', onVisibility);
      cleanups.push(function () { document.removeEventListener('visibilitychange', onVisibility); });

      if (window.IntersectionObserver) {
        var autoObserver = new IntersectionObserver(function (entries) {
          autoHold('away', !entries[entries.length - 1].isIntersecting);
        }, { threshold: 0.3 });
        autoObserver.observe(stage);
        cleanups.push(function () { autoObserver.disconnect(); });
      }

      cleanups.push(function () { clearTimeout(autoTimer); });
      autoHolds.hidden = document.hidden;
      autoSchedule();
    }

    /* ------------------------------------------------ variant switching */

    /* Takes the checked radio, not a bare id: Liquid already resolved this pack's
       M.R.P. (a real compare-at price, else the pack block's number), its rounded
       discount and its after-coupon price onto the input as data attributes. Reading
       them back beats recomputing here — one copy of the arithmetic, and the JSON
       island's compare_at_price (often null in admin) cannot disagree with the card
       the shopper is looking at. */
    function setVariant(input) {
      var v = variants[String(input.getAttribute('data-variant-id'))];
      if (!v) return;

      if (idInput) idInput.value = v.id;

      if (priceEl) priceEl.textContent = formatMoney(v.price, moneyCurrencyFormat);

      var mrp = parseInt(input.getAttribute('data-mrp'), 10) || 0;
      var off = parseInt(input.getAttribute('data-off'), 10) || 0;
      var finalPrice = parseInt(input.getAttribute('data-final'), 10) || 0;

      if (leadWasEl) {
        leadWasEl.classList.toggle('is-hidden', mrp <= 0);
        /* the inner span only — the <s> also holds a visually-hidden "M.R.P." */
        if (mrp > 0 && leadWasAmountEl) leadWasAmountEl.textContent = formatMoney(mrp, moneyFormat);
      }
      if (leadOffEl) {
        leadOffEl.classList.toggle('is-hidden', off <= 0);
        if (off > 0) leadOffEl.textContent = off + '% OFF';
      }
      if (couponEl) {
        couponEl.classList.toggle('is-hidden', finalPrice <= 0);
        if (finalPrice > 0 && couponAmountEl) {
          couponAmountEl.textContent = formatMoney(finalPrice, moneyFormat);
        }
      }

      var saving = mrp > v.price ? mrp - v.price : 0;
      if (savingEl) {
        savingEl.classList.toggle('is-hidden', saving === 0);
        if (saving > 0 && savingAmountEl) {
          savingAmountEl.textContent = formatMoney(saving, moneyFormat);
        }
      }

      if (dotEl) dotEl.classList.toggle('is-out', !v.available);
      if (availSrEl) availSrEl.textContent = v.available ? 'In stock' : 'Sold out';

      if (atcBtn) {
        atcBtn.disabled = !v.available;
        setAtcLabel(atcBtn, v.available ? 'Add to cart' : 'Sold out');
      }
      if (stickyAtc) {
        stickyAtc.disabled = !v.available;
        stickyAtc.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      if (stickyTitle) stickyTitle.textContent = v.title;
      if (stickyAmt) stickyAmt.textContent = formatMoney(v.price, moneyFormat);

      activateMedia(input.getAttribute('data-media-id'));

      /* shareable URLs; guarded — the theme editor sandbox can refuse this */
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* non-fatal */ }
    }

    root.addEventListener('change', function (evt) {
      var input = evt.target;
      if (!input.classList || !input.classList.contains('sh-pdp__pack-input')) return;
      if (!input.checked) return;
      setVariant(input);
    });

    /* ------------------------------------------------ quantity stepper */

    var qtyInput = root.querySelector('[data-sh-qty-input]');

    function clampQty() {
      if (!qtyInput) return 1;
      var n = parseInt(qtyInput.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      qtyInput.value = n;
      return n;
    }

    root.addEventListener('click', function (evt) {
      var btn = evt.target.closest ? evt.target.closest('[data-sh-qty]') : null;
      if (!btn || !root.contains(btn) || !qtyInput) return;
      var step = parseInt(btn.getAttribute('data-sh-qty'), 10) || 0;
      qtyInput.value = Math.max(1, clampQty() + step);
    });

    if (qtyInput) qtyInput.addEventListener('change', clampQty);

    /* ------------------------------------------------ countdown
       Two shapes, one ticker, and note 5's fail-closed rule holds for both: an
       invalid or spent deadline leaves the card [hidden] rather than frozen.

       'date'    — one absolute moment from section settings, the same for every
                   shopper, surviving refreshes and never re-seeding.
       'minutes' — a short window per browsing session, rendered MM:SS. The
                   deadline is stamped into sessionStorage on first sight, so
                   navigating away and back does NOT hand out a fresh clock, and
                   a window that has run out stays run out for the session. */

    var timer = root.querySelector('[data-sh-timer]');
    if (timer) {
      var digitsEl = timer.querySelector('[data-sh-timer-digits]');
      var srEl = timer.querySelector('[data-sh-timer-sr]');
      var mode = timer.getAttribute('data-sh-timer-mode') === 'minutes' ? 'minutes' : 'date';
      var deadlineMs = NaN;

      if (mode === 'minutes') {
        var windowMin = parseInt(timer.getAttribute('data-sh-timer-minutes'), 10);
        if (!(windowMin > 0)) windowMin = 10;
        var windowMs = windowMin * 60000;
        var storeKey = timer.getAttribute('data-sh-timer-key') || 'sh-pdp-offer';
        var stored = NaN;
        /* sessionStorage THROWS outright under some privacy settings, so both
           halves are guarded: a blocked store costs the timer its persistence
           and nothing else — it simply runs fresh on this pageview. */
        try { stored = parseInt(window.sessionStorage.getItem(storeKey), 10); } catch (e) { stored = NaN; }
        var nowMs = Date.now();
        if (stored > 0 && stored <= nowMs + windowMs) {
          /* a window already opened this session — honour it, spent or not */
          deadlineMs = stored;
        } else {
          /* nothing stored, or a stale stamp from a longer setting */
          deadlineMs = nowMs + windowMs;
          try { window.sessionStorage.setItem(storeKey, String(deadlineMs)); } catch (e) { /* this pageview only */ }
        }
      } else {
        /* 'YYYY-MM-DDTHH:MM' with no zone parses as the shopper's local time —
           that locality is the documented behaviour, not an accident */
        var parts = /^(\d{4})-(\d{2})-(\d{2})T(\d{1,2}):(\d{2})/.exec(timer.getAttribute('data-sh-deadline') || '');
        /* built from parts, not Date.parse(): older WebKit reads an offset-less
           ISO string as UTC, and "shopper-local" is the documented contract */
        deadlineMs = parts
          ? new Date(+parts[1], +parts[2] - 1, +parts[3], +parts[4], +parts[5], 0).getTime()
          : NaN;
      }

      if (!isNaN(deadlineMs) && deadlineMs > Date.now()) {
        var pad = function (n) { return n < 10 ? '0' + n : String(n); };
        var lastSr = 0;

        var segs = [];
        var shape = '';
        /* the span structure is built once per shape (with/without a days
           segment); every later tick only touches text nodes, so the
           document-wide MutationObserver in hov-cart-checkout.js is not
           re-triggered once a second */
        var build = function (count) {
          if (!digitsEl) return;
          digitsEl.textContent = '';
          segs = [];
          for (var k = 0; k < count; k++) {
            if (k) {
              var c = document.createElement('span');
              c.className = 'sh-pdp__timer-colon';
              c.textContent = ':';
              digitsEl.appendChild(c);
            }
            var sEl = document.createElement('span');
            sEl.className = 'sh-pdp__timer-seg';
            sEl.appendChild(document.createTextNode(''));
            digitsEl.appendChild(sEl);
            segs.push(sEl.firstChild);
          }
        };
        var write = function (values) {
          for (var k = 0; k < values.length; k++) {
            if (segs[k] && segs[k].nodeValue !== values[k]) segs[k].nodeValue = values[k];
          }
        };

        var intervalId = 0;

        var tick = function () {
          var left = deadlineMs - Date.now();
          if (left <= 0) {
            /* over means gone — never a frozen 00:00 card */
            clearInterval(intervalId);
            timer.hidden = true;
            return;
          }
          var totalSec = Math.floor(left / 1000);
          var days = Math.floor(totalSec / 86400);
          var hours = Math.floor((totalSec % 86400) / 3600);
          var mins = Math.floor((totalSec % 3600) / 60);
          var secs = totalSec % 60;

          var nextShape, values;
          if (mode === 'minutes') {
            /* MM:SS — total minutes, so a window over an hour still reads right */
            nextShape = 'ms';
            values = [pad(Math.floor(totalSec / 60)), pad(secs)];
          } else if (days > 0) {
            nextShape = 'd';
            values = [days + 'd', pad(hours), pad(mins)];
          } else {
            nextShape = 'hms';
            values = [pad(hours), pad(mins), pad(secs)];
          }
          if (nextShape !== shape) {
            shape = nextShape;
            build(values.length);
          }
          write(values);
          /* once a minute is plenty for the live region */
          if (srEl && Date.now() - lastSr > 60000) {
            lastSr = Date.now();
            srEl.textContent = mode === 'minutes'
              ? 'Offer ends in about ' + Math.ceil(totalSec / 60) + ' minutes'
              : 'Offer ends in '
                + (days > 0 ? days + ' days, ' : '')
                + hours + ' hours and ' + mins + ' minutes';
          }
        };

        tick();
        timer.hidden = false;
        intervalId = setInterval(tick, 1000);
        cleanups.push(function () { clearInterval(intervalId); });
      }
      /* invalid or past deadline: the card simply stays [hidden] */
    }

    /* ------------------------------------------------ mobile sticky bar */

    var buyRow = root.querySelector('[data-sh-buyrow]');
    if (stickyBar && buyRow) {
      var mqMobile = window.matchMedia('(max-width: 989px)');
      var hideTimeout = 0;
      var shown = false;
      var ticking = false;

      var showBar = function () {
        if (shown) return;
        shown = true;
        clearTimeout(hideTimeout);
        /* the floating WhatsApp / chat bubbles read this to lift clear of the bar */
        document.documentElement.classList.add('sh-pdp-sticky-up');
        stickyBar.hidden = false;
        stickyBar.setAttribute('aria-hidden', 'false');
        /* unhide first, slide on the next frame so the transition runs */
        if (REDUCED.matches) {
          stickyBar.classList.add('is-up');
        } else {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { stickyBar.classList.add('is-up'); });
          });
        }
      };

      var hideBar = function () {
        if (!shown) return;
        shown = false;
        document.documentElement.classList.remove('sh-pdp-sticky-up');
        stickyBar.classList.remove('is-up');
        stickyBar.setAttribute('aria-hidden', 'true');
        clearTimeout(hideTimeout);
        hideTimeout = setTimeout(function () { stickyBar.hidden = true; },
          REDUCED.matches ? 0 : 320);
      };

      /* A position check on scroll, not an IntersectionObserver: an observer
         only reports TRANSITIONS, so an anchor jump or a restored scroll
         position that lands past the buy row without it ever entering the
         viewport produces no event and the bar never appears. One
         getBoundingClientRect per coalesced frame is the whole cost. */
      var evaluateBar = function () {
        ticking = false;
        var passed = buyRow.getBoundingClientRect().bottom < 0;
        if (passed && mqMobile.matches) {
          showBar();
        } else {
          hideBar();
        }
      };

      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(evaluateBar);
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      evaluateBar();
      cleanups.push(function () {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        document.documentElement.classList.remove('sh-pdp-sticky-up');
        clearTimeout(hideTimeout);
      });

      if (stickyAtc && form && atcBtn) {
        stickyAtc.addEventListener('click', function () {
          /* a synthetic click on the REAL submit button, not requestSubmit():
             hov-cart-checkout.js enters its loading state from the click
             event and only flips to success from there, and ajax-cart's
             delegated submit handler runs either way. One POST path, one
             button showing the busy state. */
          if (atcBtn.disabled || atcBtn.hasAttribute('data-state')) return;
          atcBtn.click();
        });
      }
    }

    /* ------------------------------------------------ theme editor only
       Selecting a FAQ block in the editor sidebar opens it; selecting a
       gallery_image block shows that slide. The listener lives on the root,
       which is discarded on section unload, so there is nothing to clean up. */
    root.addEventListener('shopify:block:select', function (evt) {
      var t = evt.target;
      if (!t || !t.closest) return;
      var item = t.closest('details.sh-pdp__faq-item');
      if (item) item.open = true;
      var slide = t.closest('.sh-pdp__slide');
      if (slide) activateMedia(slide.getAttribute('data-media-id'));
    });
    /* ------------------------------------------------ registry */

    instances.push({
      root: root,
      destroy: function () {
        cleanups.forEach(function (fn) {
          try { fn(); } catch (e) { /* never let one cleanup block the rest */ }
        });
      }
    });
  }

  function boot() {
    sweep();
    var roots = document.querySelectorAll('[data-sh-pdp]');
    for (var i = 0; i < roots.length; i++) initRoot(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function (evt) {
    var gone = evt && evt.target;
    instances = instances.filter(function (inst) {
      if (gone && gone.contains && gone.contains(inst.root)) {
        inst.destroy();
        return false;
      }
      return true;
    });
  });
})();
